import React from "react";
export default function Header() {
  let date = new Date();
  return (
    <header className="container-fluid text-center py-3 bg-light d-flex align-items-center w-100 justify-content-center flex-column flex-md-row shadow shadow-sm mb-4">

<div className="pe-md-4 me-md-4 mb-3 border-end  border-3 border-muted border-0"><img className="img-fluid d-block mx-auto " style={{width:"100px"}} src={require("../images/logo.png")} alt="Logo" /></div>
      <div >
        <h2 className="fw-bold text-center text-dark m-0 ">King Fahd Specialist Hospital</h2>
        <p className=" text-center fs-5 text-muted">Nuclear medicine department</p>
      </div >
      {/* <div className=" pt-3  mb-3">
        <h1 className="fw-bold bg-info p-3 text-white rounded-3 m-0 shadow shadow-sm"> 
          King Fahd Specialist Hospital
        </h1>
      </div>
      <p className="p-x-5 py-2 shadow shadow-sm col-12 fw-medium fs-4 text-info bg-light">
        {date.toLocaleString("en-GB", { weekday: "long" })} ,{" "}
        {date.toLocaleDateString("en-GB")}
      </p> */}
    </header>
  );
}
